import { Injectable } from '@angular/core';
import { ProductAnalyticsService } from '@vendasta/product-analytics';

// Events that webchat emits: @webchat-client/src/app/services/analytics/analytics.constants.ts
export const WEBCHAT_EVENTS = {
  CHAT_START: 'inbx_web_chat_start_chat',
  SEND_MESSAGE: 'inbx_web_chat_clicked_send_message',
} as const;

@Injectable({
  providedIn: 'root',
})
export class WebchatListenerService {
  constructor(private readonly trackingService: ProductAnalyticsService) {}

  public initializeWebchatListener(): void {
    this.setupMessageListener();
  }

  private setupMessageListener(): void {
    // Listen for dataLayer events
    this.setupDataLayerListener();
  }

  private setupDataLayerListener(): void {
    if (!(window as any).dataLayer) {
      (window as any).dataLayer = [];
    }

    // Store the original push method
    const originalPush = (window as any).dataLayer.push;

    (window as any).dataLayer.push = (...args: any[]) => {
      const result = originalPush.apply((window as any).dataLayer, args);

      const event = args[0];
      if (event && typeof event === 'object' && event.event) {
        this.handleDataLayerEvent(event);
      }

      return result;
    };
  }

  private handleDataLayerEvent(event: any): void {
    const eventName = event.event;

    switch (eventName) {
      case WEBCHAT_EVENTS.SEND_MESSAGE:
        this.trackingService.trackEvent('SelfSignUp:send-webchat-message', 'SelfSignUp', 'send-webchat-message');
        break;

      case WEBCHAT_EVENTS.CHAT_START:
        this.trackingService.trackEvent('SelfSignUp:start-webchat', 'SelfSignUp', 'start-webchat');
        break;

      default:
        // Track any other webchat events
        if (eventName && typeof eventName === 'string' && eventName.includes('web_chat')) {
          this.trackingService.trackEvent(`SelfSignUp:webchat-${eventName}`, 'SelfSignUp', `webchat-${eventName}`);
        }
        break;
    }
  }
}
